import React from 'react';
import SlidesPreviewCard from './slides_preview_card';
import BillboardPreviewCard from './billboard_preview_card';

const AppSection = ({ app }) => (
    <div className="mb-10">
        <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-semibold text-gray-800">{app.name}</h2>
            <a href={app.link} className="text-sm text-blue-500 hover:text-blue-700">
                View all &rarr;
            </a>
        </div>

        {app.items.length === 0 ? (
            <div className="bg-gray-100 rounded-3xl p-8 text-center">
                <p className="text-gray-500">No {app.name.toLowerCase()} yet</p>
                <a href={app.link} className="text-sm text-blue-500 mt-2 inline-block">
                    Get started &rarr;
                </a>
            </div>
        ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {app.items.map(item => (
                    app.short_name === 'billboard'
                        ? <BillboardPreviewCard key={item.id} item={item} />
                        : <SlidesPreviewCard key={item.id} item={item} />
                ))}
            </div>
        )}
    </div>
);

export default AppSection;
